.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 88px;
  min-width: 144px;
  padding: 16px;
  border: 2px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-md);
  background: var(--tuna-palette-background-paper);
  cursor: pointer;
  transition:
    background 120ms ease,
    border-color 120ms ease;
}

.card:hover:not(:disabled) {
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-palette-action-hover);
}

.card:disabled {
  cursor: not-allowed;
}

.correct {
  border-color: var(--tuna-palette-success-main);
  background: var(--tuna-palette-success-light);
}

.incorrect {
  border-color: var(--tuna-palette-error-main);
  background: var(--tuna-palette-error-light);
}

.dimmed {
  opacity: 0.45;
}

.longName {
  font-weight: 600;
  font-size: var(--tuna-typography-fontSize-lg);
}

.shortTag {
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-palette-text-secondary);
}

@media (max-width: 599.95px) {
  .card {
    width: 100%;
  }
}
